// extracted by mini-css-extract-plugin
export var body = "WebQuoteModal-module--body--8c485";
export var feedbackFooterContainer = "WebQuoteModal-module--feedback-footer-container--833ca";
export var feedbackMessageContainer = "WebQuoteModal-module--feedback-message-container--cf557";
export var feedbackTitle = "WebQuoteModal-module--feedback-title--62fcc";
export var modalHeader = "WebQuoteModal-module--modal-header--1feee";
export var needAssistance = "WebQuoteModal-module--need-assistance--998dd";
export var needAssistanceHours = "WebQuoteModal-module--need-assistance-hours--b1f86";
export var subscriptionConfirmedMessage = "WebQuoteModal-module--subscription-confirmed-message--1bb8a";
export var subscriptionFailedMessage = "WebQuoteModal-module--subscription-failed-message--56a31";
export var thankYouBody = "WebQuoteModal-module--thank-you-body--4b33b";